const LAST_ROUTE_STORAGE_KEY = 'lastRoutePath';

export const readLastRoutePathFromStorage = () => sessionStorage.getItem(LAST_ROUTE_STORAGE_KEY);

export const writeLastRoutePathToStorage = (path: string) => {
    sessionStorage.setItem(LAST_ROUTE_STORAGE_KEY, path);
};
